import styled from '@emotion/styled';
import { Button } from '@lightspeed/flame/Button';
import { Card } from '@lightspeed/flame/Card';
import { Box, Flex } from '@lightspeed/flame/Core';
import { theme } from '@lightspeed/flame/Core/themes/flame';
import { Text } from '@lightspeed/flame/Text';

export const StyledCard = styled(Card)`
  max-width: 656px;
  width: 100%;
  padding: 12px 24px;
  padding-right: 0;
  height: fit-content;
  @media only screen and (max-width: 656px) {
    padding: 12px 16px;
  }
`;

// For the attributes marked !important, there is a css `article.section p` selector that
// changes the color, margin, and font-size that need to be overridden.
// This comes from the gui_defs ui_sections, and is defined in
// assets/scss/components/_section.scss.
export const StyledTitle = styled(Text)`
  color: ${theme.textStyles.color} !important;
  margin-bottom: 0 !important;
  font-size: 24px !important;
  line-height: 29px;
  font-weight: 700;

  @media only screen and (max-width: 656px) {
    font-size: 20px !important;
  }
`;

export const StyledBodyText = styled(Text)`
  margin: 12px 0 16px 0;
  color: ${theme.colors.textDimmed};
  font-size: 14px;
  @media only screen and (max-width: 656px) {
    margin: 8px 0 12px 0;
  }
`;

export const StyledButton = styled(Button)`
  max-width: 260px;
  width: fit-content;
  margin-bottom: 6px;
  height: auto;
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
  margin-top: 20px;
  @media only screen and (max-width: 656px) {
    margin-top: 16px;
  }
`;

export const StyledLink = styled('a')`
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-wrap: balance;
`;

export const LinkSpacer = styled(Flex)`
  a:first-child {
    margin-bottom: 4px;
  }
`;

export const StyledImageBox = styled(Box)`
  max-width: 146px;
  width: auto;
  height: auto;
  @media only screen and (max-width: 656px) {
    max-width: 120px;
  }
`;

export const StyledBannerContentFlex = styled(Flex)`
  max-height: 366px;
  margin: 16px 20px 16px 30px;
  @media only screen and (max-width: 656px) {
    margin-right: 16px;
    margin-left: 16px;
  }
`;
